import {useUser} from "../../../../../util/userContext/UserContext";

interface RoleAccessProps {
    roleAuthData: any;  // 적절한 타입으로 변경
    setRoleAuthData: React.Dispatch<React.SetStateAction<any>>;  // 상태 변경 함수 타입
}

export const RoleAccess = (props: RoleAccessProps) => {
    const {user} = useUser()

    return (
        <div className="content_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">역할 권한관리</h3>
                <div className="filter_toolbar"></div>
            </div>

            <h5 className="subheading">홈</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>매출</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio7"
                                       checked={props.roleAuthData.salesReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               salesReadYn: e.target.checked ? "Y" : "N",
                                               salesWriteYn: !e.target.checked ? "N" : props.roleAuthData.salesWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio7">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio8"
                                       checked={props.roleAuthData.salesWriteYn === "Y"}
                                       disabled={props.roleAuthData.salesReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               salesWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio8">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>해외법인</th>
                    <td colSpan={3}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio57"
                                       checked={props.roleAuthData.overseasReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               overseasReadYn: e.target.checked ? "Y" : "N",
                                               overseasWriteYn: !e.target.checked ? "N" : props.roleAuthData.overseasWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio57">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio58"
                                       checked={props.roleAuthData.overseasWriteYn === "Y"}
                                       disabled={props.roleAuthData.overseasReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               overseasWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio58">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">수주</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>수주</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio9"
                                       checked={props.roleAuthData.orderReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               orderReadYn: e.target.checked ? "Y" : "N",
                                               orderWriteYn: !e.target.checked ? "N" : props.roleAuthData.orderWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio9">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio10"
                                       checked={props.roleAuthData.orderWriteYn === "Y"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               orderWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }
                                       disabled={props.roleAuthData.orderReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                />
                                <label className="form-check-label" htmlFor="inlineRadio10">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>출하</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio11"
                                       checked={props.roleAuthData.shipmentReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               shipmentReadYn: e.target.checked ? "Y" : "N",
                                               shipmentWriteYn: !e.target.checked ? "N" : props.roleAuthData.shipmentWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio11">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio12"
                                       checked={props.roleAuthData.shipmentWriteYn === "Y"}
                                       disabled={props.roleAuthData.shipmentReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               shipmentWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio12">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>마감</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio13"
                                       checked={props.roleAuthData.endReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               endReadYn: e.target.checked ? "Y" : "N",
                                               endWriteYn: !e.target.checked ? "N" : props.roleAuthData.endWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio13">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio14"
                                       checked={props.roleAuthData.endWriteYn === "Y"}
                                       disabled={props.roleAuthData.endReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               endWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio14">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th style={{width: "16.66%"}}>세금계산서</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio15"
                                       checked={props.roleAuthData.taxReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               taxReadYn: e.target.checked ? "Y" : "N",
                                               taxWriteYn: !e.target.checked ? "N" : props.roleAuthData.taxWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio15">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio16"
                                       checked={props.roleAuthData.taxWriteYn === "Y"}
                                       disabled={props.roleAuthData.taxReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               taxWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio16">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>미수채권</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio17"
                                       checked={props.roleAuthData.accountsReceivableReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               accountsReceivableReadYn: e.target.checked ? "Y" : "N",
                                               accountsReceivableWriteYn: !e.target.checked ? "N" : props.roleAuthData.accountsReceivableWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio17">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio18"
                                       checked={props.roleAuthData.accountsReceivableWriteYn === "Y"}
                                       disabled={props.roleAuthData.accountsReceivableReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               accountsReceivableWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio18">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">제품</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>제품</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio19"
                                       checked={props.roleAuthData.productReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               productReadYn: e.target.checked ? "Y" : "N",
                                               productWriteYn: !e.target.checked ? "N" : props.roleAuthData.productWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio19">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio20"
                                       checked={props.roleAuthData.productWriteYn === "Y"}
                                       disabled={props.roleAuthData.productReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               productWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio20">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">재고</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>재고</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio21"
                                       checked={props.roleAuthData.inventoryReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               inventoryReadYn: e.target.checked ? "Y" : "N",
                                               inventoryWriteYn: !e.target.checked ? "N" : props.roleAuthData.inventoryWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio21">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio22"
                                       checked={props.roleAuthData.inventoryWriteYn === "Y"}
                                       disabled={props.roleAuthData.inventoryReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               inventoryWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio22">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>입고</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio23"
                                       checked={props.roleAuthData.inboundReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               inboundReadYn: e.target.checked ? "Y" : "N",
                                               inboundWriteYn: !e.target.checked ? "N" : props.roleAuthData.inboundWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio23">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio24"
                                       checked={props.roleAuthData.inboundWriteYn === "Y"}
                                       disabled={props.roleAuthData.inboundReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               inboundWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio24">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>출고</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio25"
                                       checked={props.roleAuthData.outboundReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               outboundReadYn: e.target.checked ? "Y" : "N",
                                               outboundWriteYn: !e.target.checked ? "N" : props.roleAuthData.outboundWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio25">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio26"
                                       checked={props.roleAuthData.outboundWriteYn === "Y"}
                                       disabled={props.roleAuthData.outboundReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               outboundWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio26">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>조정</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio27"
                                       checked={props.roleAuthData.adjustmentReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               adjustmentReadYn: e.target.checked ? "Y" : "N",
                                               adjustmentWriteYn: !e.target.checked ? "N" : props.roleAuthData.adjustmentWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio27">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio28"
                                       checked={props.roleAuthData.adjustmentWriteYn === "Y"}
                                       disabled={props.roleAuthData.adjustmentReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               adjustmentWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio28">편집</label>
                            </div>
                        </div>
                    </td>
                    <th>내역</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio29"
                                       checked={props.roleAuthData.detailsReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               detailsReadYn: e.target.checked ? "Y" : "N",
                                               detailsWriteYn: !e.target.checked ? "N" : props.roleAuthData.detailsWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio29">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio30"
                                       checked={props.roleAuthData.detailsWriteYn === "Y"}
                                       disabled={props.roleAuthData.detailsReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               detailsWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio30">편집</label>
                            </div>
                        </div>
                    </td>
                    <th>분석</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio31"
                                       checked={props.roleAuthData.analysisReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               analysisReadYn: e.target.checked ? "Y" : "N",
                                               analysisWriteYn: !e.target.checked ? "N" : props.roleAuthData.analysisWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio31">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio32"
                                       checked={props.roleAuthData.analysisWriteYn === "Y"}
                                       disabled={props.roleAuthData.analysisReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               analysisWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio32">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>바코드 인쇄</th>
                    <td colSpan={5}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio55"
                                       checked={props.roleAuthData.barcodeReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               barcodeReadYn: e.target.checked ? "Y" : "N",
                                               barcodeWriteYn: !e.target.checked ? "N" : props.roleAuthData.barcodeWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio55">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio56"
                                       checked={props.roleAuthData.barcodeWriteYn === "Y"}
                                       disabled={props.roleAuthData.barcodeReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               barcodeWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio56">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">고객</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>거래처</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio33"
                                       checked={props.roleAuthData.clientReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               clientReadYn: e.target.checked ? "Y" : "N",
                                               clientWriteYn: !e.target.checked ? "N" : props.roleAuthData.clientWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio33">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio34"
                                       checked={props.roleAuthData.clientWriteYn === "Y"}
                                       disabled={props.roleAuthData.clientReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               clientWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio34">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>연락처</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio35"
                                       checked={props.roleAuthData.contactReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               contactReadYn: e.target.checked ? "Y" : "N",
                                               contactWriteYn: !e.target.checked ? "N" : props.roleAuthData.contactWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio35">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio36"
                                       checked={props.roleAuthData.contactWriteYn === "Y"}
                                       disabled={props.roleAuthData.contactReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               contactWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio36">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>프로젝트</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio37"
                                       checked={props.roleAuthData.projectReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               projectReadYn: e.target.checked ? "Y" : "N",
                                               projectWriteYn: !e.target.checked ? "N" : props.roleAuthData.projectWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio37">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio38"
                                       checked={props.roleAuthData.projectWriteYn === "Y"}
                                       disabled={props.roleAuthData.projectReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               projectWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio38">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>티어</th>
                    <td colSpan={5}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio39"
                                       checked={props.roleAuthData.tierReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               tierReadYn: e.target.checked ? "Y" : "N",
                                               tierWriteYn: !e.target.checked ? "N" : props.roleAuthData.tierWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio39">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio40"
                                       checked={props.roleAuthData.tierWriteYn === "Y"}
                                       disabled={props.roleAuthData.tierReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               tierWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio40">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">지원</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>FAQ</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio41"
                                       checked={props.roleAuthData.faqReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               faqReadYn: e.target.checked ? "Y" : "N",
                                               faqWriteYn: !e.target.checked ? "N" : props.roleAuthData.faqWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio41">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio42"
                                       checked={props.roleAuthData.faqWriteYn === "Y"}
                                       disabled={props.roleAuthData.faqReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               faqWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio42">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>1:1문의</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio43"
                                       checked={props.roleAuthData.qnaReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               qnaReadYn: e.target.checked ? "Y" : "N",
                                               qnaWriteYn: !e.target.checked ? "N" : props.roleAuthData.qnaWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio43">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio44"
                                       checked={props.roleAuthData.qnaWriteYn === "Y"}
                                       disabled={props.roleAuthData.qnaReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               qnaWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio44">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>RMA</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio45"
                                       checked={props.roleAuthData.rmaReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               rmaReadYn: e.target.checked ? "Y" : "N",
                                               rmaWriteYn: !e.target.checked ? "N" : props.roleAuthData.rmaWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio45">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio46"
                                       checked={props.roleAuthData.rmaWriteYn === "Y"}
                                       disabled={props.roleAuthData.rmaReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               rmaWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio46">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th style={{width: "16.66%"}}>게시판</th>
                    <td colSpan={3} style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio47"
                                       checked={props.roleAuthData.boardReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               boardReadYn: e.target.checked ? "Y" : "N",
                                               boardWriteYn: !e.target.checked ? "N" : props.roleAuthData.boardWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio47">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio48"
                                       checked={props.roleAuthData.boardWriteYn === "Y"}
                                       disabled={props.roleAuthData.boardReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               boardWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio48">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 className="subheading">관리</h5>
            <table className="table table-bordered my_table table_detail">
                <tbody>
                <tr>
                    <th style={{width: "16.66%"}}>계정</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio49"
                                       checked={props.roleAuthData.accountReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               accountReadYn: e.target.checked ? "Y" : "N",
                                               accountWriteYn: !e.target.checked ? "N" : props.roleAuthData.accountWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio49">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio50"
                                       checked={props.roleAuthData.accountWriteYn === "Y"}
                                       disabled={props.roleAuthData.accountReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               accountWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio50">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>역할</th>
                    <td style={{width: "16.66%"}}>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio51"
                                       checked={props.roleAuthData.roleReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               roleReadYn: e.target.checked ? "Y" : "N",
                                               roleWriteYn: !e.target.checked ? "N" : props.roleAuthData.roleWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio51">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio52"
                                       checked={props.roleAuthData.roleWriteYn === "Y"}
                                       disabled={props.roleAuthData.roleReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               roleWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio52">편집</label>
                            </div>
                        </div>
                    </td>
                    <th style={{width: "16.66%"}}>항목</th>
                    <td>
                        <div className="frm_field">
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio53"
                                       checked={props.roleAuthData.itemReadYn === "Y"}
                                       disabled={user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               itemReadYn: e.target.checked ? "Y" : "N",
                                               itemWriteYn: !e.target.checked ? "N" : props.roleAuthData.itemWriteYn
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio53">보기</label>
                            </div>
                            <div className="form-check form-check-inline px-0">
                                <input className="form-check-input mt-1 me-2" type="checkbox" name="inlineRadioOptions"
                                       id="inlineRadio54"
                                       checked={props.roleAuthData.itemWriteYn === "Y"}
                                       disabled={props.roleAuthData.itemReadYn === "N" || user?.authority.roleWriteYn === "N"}
                                       onChange={(e) =>
                                           props.setRoleAuthData({
                                               ...props.roleAuthData,
                                               itemWriteYn: e.target.checked ? "Y" : "N",
                                           })
                                       }/>
                                <label className="form-check-label" htmlFor="inlineRadio54">편집</label>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )

}